const r = {
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  flexBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column"
  },
  ellipsisText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }
}, a = {
  resetDialog: {
    paper: {
      zIndex: 1e4
    }
  },
  uploadDialog: {
    title: {
      display: "flex",
      alignItems: "center",
      gap: 1
    },
    content: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      pt: 2
    },
    imagePreview: {
      width: "100%",
      maxHeight: "200px",
      overflow: "hidden",
      borderRadius: 1,
      border: "1px solid",
      borderColor: "divider",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    previewImage: {
      maxWidth: "100%",
      maxHeight: "200px",
      objectFit: "contain"
    },
    fileInfo: {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }
}, l = {
  container: {
    my: 0.5
  },
  addButtonsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 1
  },
  addButton: {
    textTransform: "none",
    height: "32px",
    justifyContent: "flex-start",
    pl: 2
  },
  planItem: {
    mb: 0.5,
    p: 0.5,
    display: "flex",
    alignItems: "center",
    gap: 1,
    borderRadius: 1,
    cursor: "pointer",
    "&:hover": {
      bgcolor: "action.hover"
    }
  },
  planItemActive: (e) => ({
    bgcolor: e.palette.action.selected
  }),
  planItemIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  planItemText: {
    flex: 1,
    ...r.ellipsisText
  },
  uploadButton: {
    p: 0.5
  }
}, s = {
  fullscreen: {
    height: "100vh",
    width: "100%",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1500,
    backgroundColor: "#fff",
    overflow: "hidden"
  },
  normal: {
    height: "100%",
    width: "100%",
    position: "relative",
    overflow: "hidden"
  },
  controlsContainer: { display: "flex", justifyContent: "flex-end", gap: 1 },
  controlsPaper: {
    position: "absolute",
    top: "20px",
    right: "50px",
    p: 1.5,
    zIndex: 1e3,
    width: "300px",
    maxWidth: { xs: "90%", sm: "300px" },
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(4px)",
    borderRadius: "8px",
    maxHeight: "calc(100vh - 40px)",
    overflowY: "auto",
    m: { xs: 1, sm: 2 },
    "@media (max-height: 600px)": {
      maxHeight: "80vh"
    }
  },
  topControlsContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%"
  },
  leftControls: {
    display: "flex",
    alignItems: "center"
  },
  rightControls: {
    display: "flex",
    alignItems: "center",
    gap: 1
  },
  controlButton: {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 1)"
    }
  },
  opacityControls: {
    display: "flex",
    alignItems: "center",
    gap: 1
  },
  miniControlsPaper: {
    position: "absolute",
    top: "40px",
    right: "6px",
    p: 0,
    zIndex: 1e3,
    display: "flex",
    flexDirection: "column",
    gap: 0,
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(4px)",
    borderRadius: "0px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  },
  miniControlsGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    justifyContent: "flex-end"
  },
  miniControlsRow: {
    display: "flex",
    flexDirection: "row",
    gap: 0.5,
    alignItems: "center",
    justifyContent: "flex-end"
  },
  miniControlButton: {
    minWidth: "28px",
    height: "28px",
    padding: "4px",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 1)"
    }
  },
  miniControlIcon: {
    fontSize: "18px"
  },
  miniControlDivider: {
    my: 0.5,
    mx: 0.5,
    borderColor: "divider"
  },
  expandedControls: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    transition: "all 0.2s ease",
    overflow: "hidden"
  },
  collapsedControls: {
    display: "none"
  }
}, p = {
  planIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}, d = {
  zoomWarning: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(0, 0, 0, 0.7)",
    color: "white",
    padding: "8px 12px",
    borderRadius: "4px",
    fontSize: "12px",
    pointerEvents: "none"
  },
  imageContainer: (e, t, o, i) => ({
    position: "relative",
    width: "100%",
    height: "100%",
    opacity: e ? 1 : t,
    pointerEvents: o ? "none" : e ? "auto" : "none",
    zIndex: i
  }),
  overlayContainer: (e, t, o) => ({
    width: "100%",
    height: "100%",
    position: "relative",
    transformOrigin: "center center",
    transform: e,
    transition: t ? "none" : "transform 0.1s ease-out",
    zIndex: o
  }),
  contentWrapper: {
    width: "100%",
    height: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  imageWrapper: (e) => ({
    width: "100%",
    height: "100%",
    position: "relative",
    border: e ? "1px solid rgba(0, 123, 255, 0.5)" : "none",
    overflow: "hidden"
  }),
  planImage: (e) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
    userSelect: "none",
    opacity: e,
    WebkitUserDrag: "none",
    KhtmlUserDrag: "none",
    MozUserDrag: "none",
    OUserDrag: "none",
    userDrag: "none"
  }),
  resizeHandle: (e, t, o) => {
    let n = {};
    switch (o) {
      case "topLeft":
        n = { top: -6, left: -6 };
        break;
      case "topRight":
        n = { top: -6, right: -6 };
        break;
      case "bottomLeft":
        n = { bottom: -6, left: -6 };
        break;
      case "bottomRight":
        n = { bottom: -6, right: -6 };
        break;
    }
    return {
      position: "absolute",
      width: "12px",
      height: "12px",
      background: e ? "#007bff" : "white",
      border: "2px solid #007bff",
      borderRadius: "50%",
      cursor: "crosshair",
      zIndex: 1e3,
      ...n,
      pointerEvents: "auto",
      boxShadow: "0 0 5px rgba(0,0,0,0.3)",
      display: t ? "none" : "block"
    };
  },
  rotateHandle: (e) => ({
    position: "absolute",
    top: "-30px",
    left: "50%",
    width: "28px",
    height: "28px",
    background: "white",
    borderRadius: "50%",
    cursor: "grab",
    zIndex: 1e3,
    transform: "translateX(-50%)",
    pointerEvents: "auto",
    boxShadow: "0 0 5px rgba(0,0,0,0.3)",
    display: e ? "none" : "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid #007bff"
  }),
  rotateHandleIcon: {
    width: "20px",
    height: "20px",
    position: "relative",
    color: "#007bff"
  },
  zoomIndicator: (e) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(0, 0, 0, 0.7)",
    color: "white",
    padding: "8px 12px",
    borderRadius: "4px",
    fontSize: "12px",
    pointerEvents: "none",
    display: e ? "block" : "none"
  }),
  dragArea: (e, t) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    cursor: e ? "not-allowed" : t ? "crosshair" : "move",
    zIndex: 100,
    pointerEvents: "auto"
  })
};
export {
  r as commonStyles,
  a as dialogStyles,
  p as iconStyles,
  s as mapContainerStyles,
  d as overlayWrapperStyles,
  l as planFileListStyles
};
